module.exports = __webpack_public_path__ + "static/img/natasha_pictgrid22_1060x869.c53908c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/natasha_pictgrid22_1060x869.jpg
// module id = r25J
// module chunks = 0